{
  "title": "Сессии удалённого доступа",
  "activeOnly": "Работающие",
  "all": "Все",
  "terminate": "Завершить",
  "terminateFailed": "Завершить сессию не удалось",
  "terminateForbidden": "Чужие сессии вправе завершать администратор организации.",
  "listFailed": "Список сессий недоступен",
  "emptyActive": "Сейчас никто не подключён",
  "emptyEver": "Сессий пока не было",
  "emptyHint": "Сессия появляется здесь, как только кто-то открывает VNC-консоль. Завершить чужую вправе администратор организации.",
  "trafficHint": "Принято от машины / отправлено машине",
  "kind": {
    "vnc": "VNC",
    "ssh": "Терминал",
    "videoLive": "Видео",
    "videoArchive": "Архив"
  },
  "column": {
    "who": "Кто",
    "machine": "Машина",
    "startedAt": "Начата",
    "duration": "Длится",
    "traffic": "Трафик",
    "from": "Откуда"
  },
  "endReason": {
    "clientClosed": "закрыта пользователем",
    "serverClosed": "сервер разорвал соединение",
    "agentOffline": "агент площадки отключился",
    "terminated": "завершена администратором",
    "gatewayShutdown": "шлюз остановлен",
    "handshakeFailed": "не удалось установить соединение",
    "ticketExpired": "тикет просрочен",
    "error": "сбой"
  }
}
